// ============================================================
// alert.js
// ------------------------------------------------------------
// Popup แจ้งเตือนทั้งระบบ (ครอบ SweetAlert2) + ตัวคุม loading overlay
//
// เดิมมี success / success_url / alert / alert_url / alert_2 ที่โค้ดซ้ำกันเกือบทั้งดุ้น
// ตอนนี้รวม logic ที่ซ้ำไว้ที่ fire() ตัวเดียว ส่วนตัวที่หน้าจอเรียกใช้
// ยังคงชื่อเดิม/พารามิเตอร์เดิม/ผลลัพธ์เดิมทุกตัว เพื่อไม่ให้หน้าจอไหนพัง
// ============================================================

import Swal from "sweetalert2";

// popup พื้นฐาน + ผูก Enter = กดปุ่ม "ตกลง"
// (ทุกตัวด้านล่างใช้ตัวนี้ร่วมกัน แทนที่จะ copy โค้ด didOpen ซ้ำ 4 รอบแบบเดิม)
const fire = (options) =>
  Swal.fire({
    confirmButtonText: "ตกลง",
    allowEnterKey: true,
    ...options,
    didOpen: () => {
      // กด Enter ให้เท่ากับกดปุ่มยืนยัน
      const listener = (e) => {
        if (e.key === "Enter") Swal.clickConfirm();
      };
      document.addEventListener("keydown", listener);
      // ถอด event ทิ้งเมื่อ popup ปิด กันหน่วยความจำรั่ว
      Swal.getPopup().addEventListener("closed", () => {
        document.removeEventListener("keydown", listener);
      });
    },
  });

// แจ้งว่าทำรายการสำเร็จ
export const success = () => fire({ icon: "success", title: "สำเร็จ", text: "การทำรายการสำเร็จแล้ว" });

// แจ้งว่าสำเร็จ แล้วพาไปหน้า url ที่กำหนดหลังกดตกลง
export const success_url = (url) =>
  fire({ icon: "success", title: "สำเร็จ", text: "การทำรายการสำเร็จแล้ว", closeOnClickOutside: false }).then(() => {
    window.location.href = url;
  });

// แจ้งเตือนทั่วไป — alert(icon, title, detail)
// icon = success | error | warning | info | question
export const alert = (icon, title, detail) => fire({ icon, title, text: detail });

// แจ้งเตือนทั่วไป แล้วพาไปหน้า url หลังกดตกลง
export const alert_url = (icon, title, detail, url) =>
  fire({ icon, title, text: detail, closeOnClickOutside: false }).then(() => {
    window.location.href = url;
  });

// เช็คว่าข้อความมี HTML tag ปนมาไหม (ถ้ามีต้องใช้ html: แทน text:)
const hasHTML = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);

// popup แบบยืนยัน/ยกเลิก — alert_2(url, icon, title, detail, confirm, cancel)
// - ถ้าส่ง cancel มาด้วย จะมีปุ่มยกเลิก และ return true/false ตามที่ผู้ใช้กด
// - ถ้าส่ง url มาด้วย จะพาไปหน้านั้นหลังปิด popup ("#" = reload หน้าเดิม)
// - กันเปิดซ้อน: ถ้ามี modal เปิดอยู่แล้ว 2 อัน หรือมี popup ไอคอน "!" ค้างอยู่ จะไม่เปิดเพิ่ม
export const alert_2 = (url, icon, title, detail, confirm, cancel) => {
  const modals = document.getElementsByClassName("swal2-modal");
  const icons = document.getElementsByClassName("swal2-icon");
  const hasBangIcon = Array.from(icons).some((el) => el.textContent.trim() === "!");
  if (modals.length >= 2 || hasBangIcon) return;

  return Swal.fire({
    icon: icon || "warning",
    title: title || (icon === "success" ? "สำเร็จ" : "แจ้งเตือน"),
    ...(detail
      ? hasHTML(detail)
        ? { html: detail } // มี tag → render เป็น html
        : { text: detail } // ไม่มี tag → render เป็นข้อความล้วน
      : { text: icon === "success" ? "การทำรายการสำเร็จแล้ว" : " " }),
    confirmButtonText: confirm || "ตกลง",
    showCancelButton: !!cancel,
    cancelButtonText: cancel || "ยกเลิก",
    background: "#fff",
    color: "#000000",
    confirmButtonColor: "#212529",
  }).then(({ isConfirmed }) => {
    if (url) {
      if (url === "#") window.location.reload();
      else window.location.href = url;
    }
    return isConfirmed;
  });
};

// เปิด/ปิด loading overlay (element #loading อยู่ใน index.html)
// ห่อ try/catch ไว้เพราะบางหน้า (เช่นตอน render เอกสาร) ไม่มี element นี้
export const loading = (status) => {
  try {
    const element = document.getElementById("loading");
    if (status === true) element.classList.remove("d-none");
    else if (status === false) element.classList.add("d-none");
  } catch (e) {}
};
